import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import i18n from './i18n'
import '@fortawesome/fontawesome-free/css/all.css'
import './assets/global.scss'
import VueDeviceDetector from 'vue-device-detector'
import store from './store'
import md5 from 'js-md5'
import { formatDate } from './utils/formatDate'
import { getDomainConfig, applyTheme } from './utils/domainConfig'

Vue.prototype.$md5 = md5

// 初始化域名配置
const domainConfig = getDomainConfig()
Vue.prototype.$domainConfig = domainConfig
applyTheme(domainConfig)


Vue.config.productionTip = false
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
Vue.use(VueDeviceDetector)

// 全局加载时间戳格式化方法
Vue.prototype.$formatDate = formatDate

// main.js（仅开发环境生效）
if (process.env.NODE_ENV === 'development') {
  require('./mock')
}

new Vue({
  router,
  i18n,
  store,
  render: h => h(App),
}).$mount('#app')
